import React from 'react';
import twitter from './twitter.svg';
import facebook from './facebook.svg';
import linkedin from './linkedin.svg';
import youtube from './youtube.svg';
import contact from './contact.svg';
import styles from './footer.module.scss';

const channels = [
  {
    href: 'https://twitter.com/teamgantt',
    logo: twitter,
    name: 'Twitter',
  },
  {
    href: 'https://www.facebook.com/pages/TeamGantt/267785880859',
    logo: facebook,
    name: 'Facebook',
  },
  {
    href: 'https://www.linkedin.com/company/teamgantt',
    logo: linkedin,
    name: 'LinkedIn',
  },
  {
    href: 'https://www.youtube.com/user/teamgantt',
    logo: youtube,
    name: 'YouTube',
  },
  {
    href: 'https://www.teamgantt.com/contact-us/',
    logo: contact,
    name: 'Contact',
  },
];

const Social = () => (
  <ul className={styles.Footer__socialLinks}>
    {channels.map(({href, logo, name}) => (
      <li key={name}>
        <a aria-label={name} className={styles.Footer__socialLink} href={href}>
          <img alt="" src={logo} />
        </a>
      </li>
    ))}
  </ul>
);

export default Social;



// WEBPACK FOOTER //
// ./src/components/footer/Social.js